import MobileDetect from 'mobile-detect';

export default {
    MobileDetect,
    install(Vue, opts) {
        Vue.prototype.$md = new MobileDetect(window.navigator.userAgent);
    }
}


// WEBPACK FOOTER //
// ./src/plugins/MobileDetectPlugin.js